module.exports = __webpack_public_path__ + "static/media/Blonde-Cutie.5971e30e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Blonde-Cutie.jpg
 ** module id = 422
 ** module chunks = 0
 **/